import React from 'react';
import './settings.css'
import pic35 from '../../assets/pic35.png'
import './how to play.css'
import PrimaryctaLong from './primary cta long';
import SecondaryctaLong from './seconday cta long';
import './Pause.css';
import { useNavigate } from 'react-router-dom';
import Exit from './Exit';
import Replay from './replay';
import { useState } from 'react';

const Pause = ({ onClose, replayRoute, currentLevel }) => {
  
    
    const handleClose = () => {
        setClosing(true);
        setTimeout(() => onClose(), 400);
    };


         const [closing, setClosing] = useState(false);
        const [showExit, setShowExit] = useState(false);
        const [showReplay, setShowReplay] = useState(false);
         const navigate = useNavigate();

        const handleBack = () => {
            setClosing(true);
            setTimeout(() => onClose(), 400);
        };

                const handleHome = () => {
            setShowExit(true);
        };

        const handleReplay = () => {
            setShowReplay(true);
        };


    return ( 
        <>


        {!showExit && !showReplay && (
            <section  className='settings-background' >
                <section  className={`pause-overlay ${closing ? 'slide-down' : 'slide-up'}`}>

                <section className='header-overlay'>
                    <div className='header-title-cont-settings'>
                        <h2 className='title-containerr-settings'>Pause Menu</h2>
                        <h2 className='title2-container-settings'>Pause Menu</h2>
                    </div>
                    <button className='circlecta-cont'   onClick={handleBack}>
                    <div onClick={handleBack}>
                    <div className='circle-red'>
                            <img className='close-img' src={pic35} alt='close'></img>
                    </div>
                    </div>
                    </button>
                </section>


                <section className='container-pause '>
                    <section className='container-audio'>
                        <div onClick={handleBack}>
                            <PrimaryctaLong title='Resume' />
                        </div>
                       
                        <div onClick={handleReplay}>
                            <SecondaryctaLong title='Replay' />
                        </div>
                      
                        <div onClick={handleHome}>
                             <SecondaryctaLong title='Home' />
                        </div>

                    </section>
                </section>


                </section>
            </section>

                )}

            {showExit && (
                <Exit         
                currentLevel={currentLevel}
                onCancel={() => setShowExit(false)} />
            )}
            
            {showReplay && (
                <Replay
                    replayRoute={replayRoute}
                     currentLevel={currentLevel}
                    onCancel={() => setShowReplay(false)}
                />
)}
        </>
     );
}
 
export default Pause;